<template>
  <li :class="['nav-item', { 'active' : selected }]">
    <slot />
  </li>
</template>

<script>
export default {
  name: 'WptvMenuItem',

  props: {
    selected: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @import '../../../scss/abstracts/variables';

.nav-item {
  white-space: nowrap;
  a:focus:not(:focus-visible) {
    outline: none;
  }
  a:focus-visible {
    outline: solid 2px $primary;
  }
}
</style>
